import { createTheme, MantineColorsTuple } from '@mantine/core';

// Нейтральная тема продукта (docs/decisions.md, 26.10.2026): фон #F6F6F3, акцент #1F6E8C.
// Цвет клиники — её настройка, а не продукта.
const brand: MantineColorsTuple = [
  '#e9f4f8', '#d3e6ee', '#a4cddd', '#72b2cb', '#4b9cbc', '#338eb2', '#1F6E8C', '#1a5f79', '#145066', '#0c3f52',
];

export const theme = createTheme({
  primaryColor: 'brand',
  primaryShade: 6,
  colors: { brand },
  fontFamily: 'Onest, system-ui, sans-serif',
  headings: { fontFamily: 'Onest, system-ui, sans-serif', fontWeight: '600' },
  defaultRadius: 'md',
  radius: { md: '12px', lg: '16px', xl: '20px' },
  black: '#1D1B20',
  components: {
    Paper: { defaultProps: { withBorder: true, radius: 'lg' } },
    Button: { defaultProps: { radius: 'md' } },
  },
});

export const SURFACE = '#F6F6F3';
export const BORDER = '#ECEAE5';
export const MUTED = '#66636B';
